'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavDrawerHeader", {
    enumerable: true,
    get: function() {
        return NavDrawerHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdrawer = require("@fluentui/react-drawer");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavDrawerHeaderStylesstyles = require("./useNavDrawerHeaderStyles.styles");
const _useNavDrawerHeader = require("./useNavDrawerHeader");
const NavDrawerHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavDrawerHeader.useNavDrawerHeader_unstable)(props, ref);
    (0, _useNavDrawerHeaderStylesstyles.useNavDrawerHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavDrawerHeaderStyles_unstable')(state);
    return (0, _reactdrawer.renderDrawerHeader_unstable)(state);
});
NavDrawerHeader.displayName = 'NavDrawerHeader';
